import { render, staticRenderFns } from "./WorkProgressStateComponent.vue?vue&type=template&id=b45bcdc8&"
import script from "./WorkProgressStateComponent.vue?vue&type=script&lang=js&"
export * from "./WorkProgressStateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b45bcdc8')) {
      api.createRecord('b45bcdc8', component.options)
    } else {
      api.reload('b45bcdc8', component.options)
    }
    module.hot.accept("./WorkProgressStateComponent.vue?vue&type=template&id=b45bcdc8&", function () {
      api.rerender('b45bcdc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/WorkProgressStateComponent.vue"
export default component.exports